import React from "react";

export const RedactedText = ({ children, label = "CLASSIFIED" }) => (
  <span
    className="redacted font-mono text-sm"
    title={label}
    aria-label={`${label} text — hover to reveal`}
    data-testid="redacted-text"
  >
    {children}
  </span>
);

export default RedactedText;
